module.exports = __webpack_public_path__ + "static/eventDetail1-afd4f5fdf3ae1e44b5a5a2015b669746.png";